/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-07 18:55:23
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-01 17:10:04
 */
import React, {PureComponent, Fragment} from 'react'
import {Avatar, Badge, message, Menu, Dropdown} from "antd";
import {AddRoomLastMsg, DeleteRoomUnReadMsg, ChangeRoom, DeleteTalkList} from '../../../../store/actionCreators'
import {connect} from 'react-redux'
import {select} from 'react-cookies';
import {Link} from 'react-router-dom';
import axios from 'axios';
import FreeScrollbar from '../../../components/滚动条';
import {customlog, transformtimesimple} from '../../../../utils/tools';
// import { TalkEntity } from 'src/modules/localEntity';
// interface Props {
//     activeRoom: TalkEntity,
//     talkList: TalkEntity[],
//     DeleteTalkList: Function,
//     ChangeRoom: Function,
//     searchtext: string
// }

let glob = global

class ChatList extends React.Component {
    // searchresultsrcoll
    shouldComponentUpdate(nextProp) {
        // console.log("聊天消息头像文件检查：",this.props.talkList[0]);
        // console.log(nextProp.talkList);
        if (nextProp.talkList != this.props.talkList) {
            this.refreshScroll()
            // if (nextProp.activeRoom) {
            //     for (let i = 0; i < nextProp.talkList.length; i++) {
            //         if (nextProp.talkList[i].roomId === nextProp.activeRoom.roomId) {
            //             this.searchresultsrcoll.setPosition({ top: 200 })
            //             return true
            //         }
            //     }
            // }
        }
        return true
    }

    /*删除会话 */
    deleteChat = async (serial) => {
        // debugger
        // axios.delete(`${global.serviceUrl.chat}/contact/del?serial=${serial}`).then((data) => {
        //     let r = data.data
        //     if (r.code === '200') {
        //         message.success('删除会话成功！')
        //         if (this.props.activeRoom && this.props.activeRoom.serial === serial) {
        //             this.props.ChangeRoom({ roomInfo: null })
        //         }
        //         this.props.DeleteTalkList({ serial: serial })
        //     } else {
        //         // debugger
        //     }
        // }).catch((e) => {
        //     message.error(e)
        // })
        message.success('删除会话成功！')
        if (this.props.activeRoom && this.props.activeRoom.serial === serial) {
            this.props.ChangeRoom({roomInfo: null})
        }
        this.props.DeleteTalkList({serial: serial})
        const {data: res} = await axios.delete(`${global.serviceUrl.chat}/contact/del?serial=${serial}`)
        if (res.code === '200') {

        }
    }
    changeroom = (info) => {
        customlog('接受到点击会话指令', 'start')
        if (!this.props.activeRoom || (this.props.activeRoom.roomId !== info.roomId)) {
            this.props.ChangeRoom({roomInfo: info})
            axios.post(`${global.serviceUrl.chat}/msg/save`,{contactSerial:info.serial,messageSerial:info.messageId})
        }
    }
    refreshScroll = () => {
        // setTimeout(() => {
        this.searchresultsrcoll.collectInfo()
        this.searchresultsrcoll.handlerContainerScroll();
        // }, 100)
    }

    render() {
        const menu = (info) => <Menu>
            <Menu.Item key="1" onClick={this.deleteChat.bind(this, info.serial)}>{'删除会话'}</Menu.Item>
        </Menu>
        // console.log("this.props.talkList", this.props.talkList)
        return (
            <FreeScrollbar ref={ref => this.searchresultsrcoll = ref} className='chatlist-customscroll'>
                {
                    this.props.talkList.map((info, index) => {
                            // console.log('聊天室头像文件',info.avatar && info.avatar.includes(global.yunguanAvatar) ? info.avatar : global.yunguanAvatar + info.avatar);
                            // let avatarUrl=info.avatar && info.avatar.includes(global.yunguanip1) ? info.avatar : global.yunguanAvatar + info.avatar;
                            let avatarUrl;
                            if (info.type === "public") avatarUrl = info.avatar?info.avatar:"";
                            else if (info.type === "private") avatarUrl = info.avatar && global.yunguanAvatar + info.avatar;
                            // console.log('聊天室头像文件', info);
                            // console.log('检查是否有头像为null',info.avatar);
                            return <Link to='/Chat/Room' key={index}>
                                <Dropdown overlay={menu.bind(this, info)} key={info.serial} trigger={['contextMenu']}>
                                    <div
                                        className={this.props.activeRoom && (this.props.activeRoom.roomId === info.roomId) ?
                                            `chat-list-instance chat-list-instance-active` : 'chat-list-instance'}
                                        // data={info}
                                        // key={info.roomId}
                                        onClick={this.changeroom.bind(this, info)}
                                        style={{display: (info.chatName.indexOf(this.props.searchtext) != -1 || info.lastMsg.indexOf(this.props.searchtext) != -1) ? 'flex' : 'none'}}
                                    >
                                        <Badge size={'small'} count={info.unReadMsg}>
                                            <Avatar
                                                // src={info.avatar && info.avatar.includes(global.yunguanAvatar) ? info.avatar : global.yunguanAvatar + info.avatar}
                                                src={avatarUrl}
                                                className={'.chatavatar'}></Avatar>
                                        </Badge>
                                        <div className='chatlist-text'>
                                            <div className='chatlist-chatname'>
                                                {info.chatName.split(this.props.searchtext).map((text, index) => {
                                                    return (<span key={index}><span
                                                        style={{background: 'yellow'}}>{index !== 0 && this.props.searchtext}</span><span>{text}</span></span>)
                                                })}
                                            </div>
                                            <div className='chatlist-time'>
                                                {info.lastMsgTime ? transformtimesimple(info.lastMsgTime) : ''}
                                            </div>
                                            <div className='chatlist-lastmessage'>
                                                {/* {info.lastMsg} */}
                                                {info.lastMsg.split(this.props.searchtext).map((text, index) => {
                                                    return (<span key={index}><span
                                                        style={{background: 'yellow'}}>{index !== 0 && this.props.searchtext}</span><span>{text}</span></span>)
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </Dropdown>
                            </Link>
                        }
                    )}
            </FreeScrollbar>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
    talkList: state.userReducer.get('talkList').toJS(),
    friendApplication: state.userReducer.get('friendApplication').toJS(),
    activeRoom: state.userReducer.get('activeRoom'),
})

const mapDispatch = dispatch => ({
    ChangeRoom(param) {
        dispatch(ChangeRoom(param))
    },
    DeleteTalkList(param) {
        dispatch(DeleteTalkList(param))
    },
})

export default connect(
    mapState,
    mapDispatch
)(ChatList)
